import { supabase } from './supabase';

export async function getSupabaseAccessToken(): Promise<string> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error('Not authenticated (missing access token)');
  return token;
}

